module.exports = __webpack_public_path__ + "img/chess_japanchess09.6d5bf443.png";